import { render, staticRenderFns } from "./f.vue?vue&type=template&id=3bac5115&scoped=true&"
import script from "./f.vue?vue&type=script&lang=js&"
export * from "./f.vue?vue&type=script&lang=js&"
import style0 from "./f.vue?vue&type=style&index=0&id=3bac5115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac5115",
  null
  
)

export default component.exports